/**
 * Conversiones de valores crudos de la base de datos.
 *
 * PostgREST devuelve números como texto en algunas columnas y `null` en otras,
 * y las vistas han ido cambiando de forma con el tiempo. Centralizar aquí la
 * tolerancia evita repetir comprobaciones defensivas en cada traductor.
 */

export function aNumero(valor: unknown): number | null {
  if (valor === null || valor === undefined || valor === '') return null;
  const n = Number(valor);
  return Number.isFinite(n) ? n : null;
}

export function aTexto(valor: unknown): string | null {
  if (valor === null || valor === undefined) return null;
  const t = String(valor).trim();
  return t === '' ? null : t;
}

/** `null` cuando el valor no es un booleano reconocible, no `false`. */
export function aBooleano(valor: unknown): boolean | null {
  if (valor === null || valor === undefined || valor === '') return null;
  if (typeof valor === 'boolean') return valor;
  if (typeof valor === 'number') return valor !== 0;

  const t = String(valor).trim().toLowerCase();
  if (['true', 't', '1', 'si', 'sí', 'on'].includes(t)) return true;
  if (['false', 'f', '0', 'no', 'off'].includes(t)) return false;
  return null;
}

export function aFecha(valor: unknown): Date | null {
  if (!valor) return null;
  const fecha = valor instanceof Date ? valor : new Date(String(valor));
  return Number.isNaN(fecha.getTime()) ? null : fecha;
}

/**
 * Objeto guardado en una columna JSON.
 * Puede llegar ya deserializado o como texto según la vista.
 */
export function aObjeto(valor: unknown): Record<string, unknown> {
  if (!valor) return {};

  if (typeof valor === 'string') {
    try {
      const parseado: unknown = JSON.parse(valor);
      return parseado && typeof parseado === 'object' ? (parseado as Record<string, unknown>) : {};
    } catch {
      return {};
    }
  }

  return typeof valor === 'object' ? (valor as Record<string, unknown>) : {};
}
